import { SearchItem, SearchItemType } from "@components/Store/StoreSearchInput/storeSearchInput.types";
import { isDefined } from "@utils/helpers";

export const geocodeMapper = (geocode: woosmap.map.localities.LocalitiesGeocodeResult): SearchItem => {
    const locality = geocode.address_components?.find(ac =>
        ac.types.some(t => t === "locality"),
    );
    const county = geocode.address_components?.find(ac =>
        ac.types.some(t => t === "county"),
    );
    const country = geocode.address_components?.find(ac =>
        ac.types.some(t => t === "country"),
    );

    const label = [locality, county, country]
        .filter(isDefined)
        .map((addressComponent => addressComponent.long_name))
        .join(", ");

    return {
        value: geocode.public_id,
        latitude: geocode.geometry?.location.lat,
        longitude: geocode.geometry?.location.lng,
        label: label,
        type: SearchItemType.Locality,
    }
}
